@use "../../../styles/mixins";

.root {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-items: center;

  padding-block: 0.125rem;

  overflow-wrap: anywhere;
}

.contentBox {
  position: relative;
  z-index: 0;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;

  max-width: 15rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius-messages);

  color: white;

  @include mixins.action-message-bg($isModule: true);
}

.textContent {
  position: relative;
  z-index: 0;

  display: inline-block;

  max-width: 100%;
  padding: 0.1875rem 0.5rem;
  border-radius: var(--border-radius-messages);

  color: white;

  @include mixins.action-message-bg($isModule: true);
}

.hasFullContent {
  & > .textContent,
  & > .inlineWrapper {
    margin-bottom: 0.5rem;
  }
}

.singleLine .textContent {
  display: inline-flex;
  white-space: pre;
}

.strong {
  font-weight: var(--font-weight-medium);
}

.messageLink {
  overflow: hidden;
  min-width: 1ch;
}

.noEllipsis {
  overflow: visible;
  min-width: auto;
}

.singleLine, .messageLink {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.withLinkBreaks .messageLink {
  white-space: normal;
}

.inlineWrapper {
  grid-area: 1 / 1;
  max-width: 100%;
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.inlineButtons {
  width: 100%;
}

.contextContainer {
  grid-area: 1 / 1;
}

.fluidMultiline {
  background-color: transparent;

  // These two elements should align perfectly
  .fluidBackground, .textContent {
    display: inline;

    padding: 0.1875rem 0.5rem;
    border-radius: var(--border-radius-messages);

    text-wrap: pretty;

    box-decoration-break: clone;
  }

  .fluidBackground {
    pointer-events: none;
    color: black;
    // Solid color for filter
    background-color: black;
  }

  .textContent {
    background-color: transparent !important;
    backdrop-filter: none !important;
  }
}

.info {
  position: relative;
  font-size: 0.9375rem;
}

.stickerWrapper {
  position: relative;
}

.channelPhoto {
  --radius: var(--border-radius-messages);
}

.suggestedAvatar {
  margin-top: 0.25rem 0.125rem;
}

.suggestedText {
  text-wrap: balance;
}

.birthdayValues {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.birthdayValue {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: var(--font-weight-medium);
}

.birthdayValueLabel {
  font-size: 0.75rem;
  font-weight: var(--font-weight-normal);
  opacity: 0.75;
}

.actionButton {
  cursor: var(--custom-cursor, pointer);

  position: relative;

  display: inline-block;

  padding: 0.5rem 1.25rem;
  border-radius: 1.25rem;

  font-weight: var(--font-weight-semibold);

  @include mixins.action-message-bg($isModule: true);

  transition: opacity 0.15s;

  &:hover,
  &:focus {
    opacity: 0.8;
  }
}

.title {
  margin-bottom: 0;
  font-size: inherit;
}

.subtitle {
  font-size: 0.8125rem;
  text-wrap: balance;
}

.starGift {
  cursor: var(--custom-cursor, pointer);
  width: 13.75rem;
}

.uniqueGift {
  margin-block: 0.25rem;

  &::before {
    content: "";

    position: absolute;
    z-index: -1;
    inset: -0.25rem;

    border-radius: calc(var(--border-radius-messages) + 0.25rem);

    @include mixins.action-message-bg($isModule: true);
  }
}

.uniqueBackgroundWrapper {
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: inherit;
}

.uniqueBackground {
  position: absolute;
  inset: 0;
}

.uniqueValue {
  color: white;
}

.suggestedPostContainer {
  padding: 0.5rem 0.75rem !important;
}

.suggestedPostTitle {
  width: 100%;
  max-width: 10rem;
  font-weight: var(--font-weight-normal);
  text-align: center;
}

.suggestedPostInfo {
  width: fit-content;
  margin: 0.75rem auto 0;
}

.suggestedPostBalanceTooLowBox,
.suggestedPostRejectedContentBox,
.suggestedPostContentBox,
.hoverable .textContent {
  cursor: var(--custom-cursor, pointer);
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.8;
  }
}

.suggestedPostContentBox {
  max-width: 20rem !important;
}

.suggestedPostBalanceTooLowBox {
  max-width: 20rem !important;
  text-align: center;
}

.suggestedPostBalanceTooLowTitle {
  margin-bottom: 0.25rem;
}

.suggestedPostRejectedContentBox {
  max-width: 15rem !important;
}

.suggestedPostApprovalTitle {
  display: flex;
  justify-content: center;

  width: 100%;
  margin-bottom: 0.375rem;

  font-weight: var(--font-weight-medium);
}

.suggestedPostApprovalSection {
  width: 100%;
  margin-bottom: 0.375rem;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.suggestedPostRejectedComment {
  width: 100%;
  text-align: center;
}

.suggestedPostRejectedTitle {
  display: inline-block;
  text-align: center;
}

.rejectedIcon {
  margin-right: 0.125rem;
  font-size: 1rem;
  vertical-align: middle;
}

.botForumTopicIcon {
  padding: 1.25rem;
  border-radius: 50%;
  font-size: 2.5rem;

  @include mixins.action-message-bg($isModule: true);
}

.botForumTopicTitle {
  margin-block: 0.5rem 0;
}

.botForumTopicDescription {
  font-weight: var(--font-weight-normal);
}

.botForumTopicArrow {
  font-size: 1.5rem;
  opacity: 0.5;
}

.narrowWrapper {
  max-width: 18rem;
}
